<style lang="less" scoped>

</style>
<template>
  <VRemoteSelect
    v-bind="$attrs"
    item-value="id"
    item-selected="account"
    :item-text="(c) => (`${c.account}-${c.team_name}`)"
    :find_api="$util.api.find_customer"
    :search_api="$util.api.customer_select_search"
    :item-default="{id: 0, account: '', team_name: ''}"
    v-on="$listeners"
  />
</template>
<script>
  import VRemoteSelect from '../../../vuetify_custom/v-remote-select';
  export default {
    components: { VRemoteSelect },
    inheritAttrs: false,
  }
</script>
